<template>
  <div class="security-picker">
    <!-- 输入框 -->
    <van-field
      required
      readonly
      error-message=" "
      :value="fieldValue"
      :label="label"
      :name="name"
      :placeholder="'请选择' + label"
      :rules="[{ required: true, message: '请选择' + label }]"
      @click="clickField"
      input-align="right"
    ></van-field>

    <!-- 弹出层 -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      @open="openSelector()"
      @close="closeSelector()"
    >
      <div class="security-picker-selector">
        <!-- 按钮 -->
        <div class="selector-header">
          <div @click="isShowPopup = false">取消</div>
          <div @click="clickComfirm">确定</div>
        </div>
        <!-- 搜索  -->
        <div class="selector-search">
          <van-cell-group>
            <van-field
              v-model="searchValue"
              placeholder="输入搜索"
              input-align="center"
              clearable
              @input="inputSelectorSearch"
            />
          </van-cell-group>
        </div>
        <!-- 列表 -->
        <div class="selector-content">
          <div
            :class="[
              'selector-content-item',
              {
                active:
                  item.selectorItemId ===
                  (selectorActive.selectorItemId
                    ? selectorActive.selectorItemId
                    : ''),
              },
            ]"
            v-for="(item, index) in selectorSearchList"
            :key="index"
            @click="clickSelectorItem(item)"
          >
            {{ item.selectorItemLabel }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowPopup: false, // 弹出层
      fieldValue: "", // 输入框
      searchValue: "", // 搜索框
      selectorList: [], // 选择器list
      selectorSearchList: [], // 选择器list
      selectorActive: {}, // 选择器选中
    };
  },
  methods: {
    // 弹出层关闭时
    closeSelector() {
      this.selectorActive = {};
    },
    // 弹出层打开时
    openSelector() {
      if (!this.parentSelectorActive.GID) return;
      this.selectorActive = this.parentSelectorActive;
    },
    // 输入框事件
    inputSelectorSearch() {
      this.selectorSearchList = this.selectorList.filter((item) => {
        return item.selectorItemLabel.includes(this.searchValue);
      });
    },
    // 传父级
    handlerTransferParent() {
      this.$emit("comfirm", this.selectorActive, this.name);
    },
    // 点击选项
    clickSelectorItem(data) {
      this.selectorActive = data;
    },
    // 点击弹出层确定按钮
    clickComfirm() {
      this.fieldValue = this.selectorActive.selectorItemLabel;
      this.handlerTransferParent();
      this.isShowPopup = false;
    },
    // 处理请求返回数据
    handlerQueryData(data, type) {
      this.isShowPopup = true;
      let temp = data.map((item) => {
        return {
          ...item,
          selectorItemLabel: item[type],
          selectorItemId: item.GID,
        };
      });
      this.selectorSearchList = temp;
      this.selectorList = temp;
    },
    // 点击输入框
    clickField() {
      this.searchValue = "";

      // 线路
      this.$http.post(this.$api.SecurityLine).then((res) => {
        this.handlerQueryData(res.data, "LineName");
      });
    },
  },
  props: {
    label: {
      type: [String],
    },
    name: {
      type: [String],
    },
    parentSelectorActive: {
      type: [Object],
    },
  },
};
</script>
<style lang="less" scoped>
.security-picker {
  border-bottom: 1px solid #dddddd85;

  /deep/.van-cell {
    font-size: 0.42rem;
    .van-cell__title,
    .van-cell__value {
      color: #000;
    }
  }
  .van-cell::after {
    border: none;
  }

  .security-picker-selector {
    height: 60vh;
    display: flex;
    flex-direction: column;
    .selector-header {
      display: flex;
      justify-content: space-between;
      font-size: 0.4rem;
      padding: 0.3rem 0.4rem;
      border-bottom: 1px solid #dddddd85;

      & > :nth-child(1) {
        color: #aaa;
      }
      & > :nth-child(2) {
        color: #4ea1e1;
      }
    }
    .selector-search {
      border-bottom: 1px solid #dddddd85;

      /deep/ .van-cell-group::after {
        border: none;
      }
      /deep/ .van-field__control {
        font-size: 0.42rem;
      }
    }
    .selector-content {
      flex: 1;
      padding: 0 0.5rem;
      overflow: auto;

      .selector-content-item {
        padding: 0.3rem 0.4rem;
        font-size: 0.42rem;
        border-bottom: 1px solid #eeeeee81;
      }
      .active {
        background-color: #ddd;
      }
    }
  }
}
</style>
